export namespace Constants {
  export const enum PieceStyles {
    Default = 'staunton_executive', // the actual 3d piece style
    Trigger = 'real3d', // the piece style board option that triggers a renderer update
  }

  export const enum CacheKeys {
    CameraSettings = 'cameraSettings',
  }

  export const enum CssClasses {
    Board = 'board-webgl-3d',
    PieceDrag = 'piece-dragging',
    PieceHover = 'piece-hover',
    PromotionWindow = 'promotion-window-3d',
    StatisticsPanel = 'statistics-panel',
  }

  /**
   * Render order for transparent objects to avoid depth artifacts/overlap.
   */
  export const enum ObjectsRenderOrder {
    AnalysisOverlay = 1,
    NotationPlane = 2,
    OverSquare = 3,
    HighligtedSquare = 4,
    Hint = 5,
    CustomItem = 6,
    PieceShadow = 7,
    Arrow = 8,
    Effect = 9,
    Highest = 10,
  }

  export const enum Arrow {
    /**
     * The Y (vertical) position for an arrow.
     */
    PositionY = 0.005,
  }

  export const enum CustomItem {
    /**
     * The Y (vertical) position for a custom item.
     */
    PositionY = 0.005,
  }

  export const enum Effect {
    /**
     * The Y (vertical) position for an effect.
     */
    PositionY = 0.005,
  }

  export const enum Square {
    /**
     * The chess board square size.
     */
    Size = 10,

    /**
     * The chess board half square size.
     */
    HalfSize = Size / 2,

    /**
     * The border size for marking squares.
     */
    BorderSize = 0.5,

    /**
     * The border size for square over plane.
     */
    OverBorderSize = 0.5,

    /**
     * The Y (vertical) position for a square to be visible (used mainly for square over plane).
     */
    VisibleY = 0.005,

    /**
     * The Y (vertical) position for a square to be hidden (used mainly for square over plane).
     */
    InvisibleY = -0.2,

    /**
     * The minimum distance a position is considered to be inside the square.
     */
    InsideTolerance = 0.01,
  }

  export const enum Board {
    /**
     * The chess board margin size.
     */
    MarginSize = 4,

    /**
     * The chess board size.
     */
    Size = Square.Size * 8 + MarginSize * 2,
  }

  export const enum Camera {
    Distance = 140,
    DistanceMin = 50,
    DistanceMax = 500,
    PanAngle = 0,
    TiltAngle = 100,
    HorizontalPanning = 0,
    VerticalPanning = -12,
    ZoomIncrement = 5,
  }
}
